export default "__VITE_ASSET__BwrawRAd__"